export default {
    WHITELISTED: 0,
    DIRTY: 1,
    BLACKLISTED: 1,
    FAILED_TO_SCAN: 3,
    UNKNOWN: 5,
};
